import { useStyles } from './styles'

export const StoreButton = ({ store, link, height = 130, width = 40 }) => {
  const classes = useStyles({ store, height, width })
  const handleClick = () => window.open(link, '_blank')
  return <div role={'presentation'} className={classes.storeButton} onClick={handleClick}></div>
}
